<button *ngIf="type === 'flat'" mat-flat-button [color]="color" [disabled]="disabled" (click)="onClick()">
  <svg class="svg" *ngIf="spriteSvgName">
    <use [ogSvgUnify]="'assets/sprite/sprite.svg#' + spriteSvgName"></use>
  </svg>
  <mat-icon *ngIf="matIconName">{{ matIconName }}</mat-icon>
  <span *ngIf="text">{{ matIconName || spriteSvgName ? ' ' + text : text }}</span>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<button *ngIf="type === 'stroked'" mat-stroked-button [color]="color" [disabled]="disabled" (click)="onClick()">
  <svg class="svg" *ngIf="spriteSvgName">
    <use [ogSvgUnify]="'assets/sprite/sprite.svg#' + spriteSvgName"></use>
  </svg>
  <mat-icon *ngIf="matIconName">{{ matIconName }}</mat-icon>
  <span *ngIf="text">{{ matIconName || spriteSvgName ? ' ' + text : text }}</span>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<button *ngIf="type === 'icon'" mat-icon-button [color]="color" [disabled]="disabled" (click)="onClick()">
  <svg class="svg" *ngIf="spriteSvgName">
    <use [ogSvgUnify]="'assets/sprite/sprite.svg#' + spriteSvgName"></use>
  </svg>
  <mat-icon *ngIf="matIconName">{{ matIconName }}</mat-icon>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
